import React, { useState, useRef, useEffect } from "react";
import ConnectWallet from "./ConnectWallet";
export default function MintWhite() {
  const [mint, setMint] = useState("noButtons");
  const [audioStatus, changeAudioStatus] = useState(false);
  const [preMintText, afterMintText] = useState(true);

  // Play Audio
  const myRef = useRef();
  const newref = useRef();

  const startAudio = () => {
    myRef.current.play();
    //reduce speed of audio
    //reduce voice of audio

    myRef.current.playbackRate = 1;
    myRef.current.volume = 0.5;
    changeAudioStatus(true);
  };

  //toogle audio on off
  const toggleAudio = () => {
    if (audioStatus) {
      myRef.current.pause();
      changeAudioStatus(false);
    } else {
      myRef.current.play();
      changeAudioStatus(true);
    }
  };

  // Show Buttons
  const showButtons = () => {
    setMint("mintButtons");
    afterMintText(!preMintText);
    // startAudio();
  };

  useEffect(() => {
    startAudio();
  }, []);

  return (
    <div
      to="/mint"
      className="col-md-6 d-flex flex-column align-items-center justify-content-center bg-white mint__right"
    >
      {/* Audio */}
      <audio ref={myRef} loop src="/images/music.mp3" />

      {/* Social Icons */}
      <div className="s__icons mt-1 flex align-items-center">
        <a
          href="https://twitter.com/TheRealHodlerz"
          target="_blank"
          className="s_icon"
        >
          <img src="/images/socials/twitter-icon.png" alt="" />
        </a>
        <a
          href="https://opensea.io/collection/thehodlerz"
          target="_blank"
          className="s_icon"
        >
          <img src="/images/socials/opensea-icon.png" alt="" />
        </a>
        <a className="s_icon" onClick={toggleAudio}>
          {audioStatus ? (
            <img src="/images/socials/pause.png" />
          ) : (
            <img src="/images/socials/play.png" />
          )}
        </a>
      </div>
      <h6 className="mt-2 col-4 text-end">THE HODLERZ</h6>

      {/* Red Box */}
      <img onClick={showButtons} src="/images/red.png" alt="" />
      {/* <div className="text__small mt-3 text-center">
        <h4 className="m-0" onClick={showButtons}>
          Mint Here
        </h4>
        <h6>
          1 FREE TO MINT <br /> THEN O.01 ETH <br /> MAX 10X WALLET
        </h6>
      </div> */}

      {preMintText ? (
        <div className="text__small mt-3 text-center">
          <h4 className="m-0" onClick={showButtons}>
            MINT HERE
          </h4>
          <h6>
            1 FREE TO MINT <br /> THEN 0.01 ETH <br /> MAX 10X WALLET
          </h6>
        </div>
      ) : (
        <div className="text__small mt-3 text-center">
          <h4 className="m-0" onClick={showButtons}>
            BE GREEDY
          </h4>
          <h6>
            CCO <br /> ART ONLY <br />
            SMART CONTRACT{" "}
            <a href="https://etherscan.io/address/" target="_blank">
              HERE
            </a>
            {/* . */}
          </h6>
        </div>
      )}

      {/* <div className="text__small mt-3 text-center">
        <h4 className="m-0" onClick={showButtons}>
          XXXXXX
        </h4>
        <h6>
          hjdgjf <br /> THEdsdsdsasdH <br /> MAXsdasad
        </h6>
      </div> */}

      {/* Input Buttons */}
      <div className={mint}>
        <input min={0} placeholder="0" type="number" className="mint__button" />
        <ConnectWallet />
      </div>

      {/* White Box Small Text */}
      <footer className="d-flex w-100 align-items-center justify-content-between">
        <div className="col-6">
          <h6 className="mx-3">THE HODLERZ</h6>
        </div>
        <div className="col-6">
          <h6 className="text-end mx-3">DAZE STUDIO</h6>
        </div>
      </footer>
    </div>
  );
}
